import React, {useEffect, useRef, useState} from "react";
import {getToolTipMsg} from "../../client-data/DisplayTooltip";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import {MOBILE_TOOLTIP_TIMEOUT} from "../../client-data/GlobalConstants";

function V21DropdownItem(props) {
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const timeOutRef = useRef(null);
    const parentProps = props;
    const style = {
        display: 'inline-block'
    }

    function onClick(evt) {
        /* We have disabled the functionality in which you have to click-two times on the menu icon
        to see first the tooltip, then second click to perform the functionality
        @Author: Rana
        @Date: April 11th, 2024
        */
        // if (!show) {
        //
        //     setShow(true);
        //     timeOutRef.current = setTimeout(() => {
        //         setShow(false);
        //     }, MOBILE_TOOLTIP_TIMEOUT);
        // } else {
        setShow(false);
        if (props.onClick) {
            props.onClick(evt);
        }
        // }
    }

    function loseFocus(evt) {
        setShow(false);
    }

    useEffect(() => {
        return () => {
            console.log(" Before unmounting!");
            clearTimeout(timeOutRef.current);
        }
    }, []);

    return (
        <div>
            <button ref={target} className="menu-item v21-button-menu-item"
                    onClick={evt => onClick(evt)} onBlur={(evt) => loseFocus(evt)}>
                <span style={style}><img src={props.leftIcon} className="icon-button"/></span>
                {props.children}
            </button>
            <Overlay target={target.current} show={show} placement="left">
                {(props) => (
                    <Tooltip id="overlay-example" {...props}>
                        {getToolTipMsg(parentProps.tooltip_type)}
                    </Tooltip>
                )}
            </Overlay>
        </div>
    );
}

export default V21DropdownItem;
